import { render, staticRenderFns } from "./ExamQuestion.vue?vue&type=template&id=129eb2c8&scoped=true&"
import script from "./ExamQuestion.vue?vue&type=script&lang=js&"
export * from "./ExamQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ExamQuestion.vue?vue&type=style&index=0&id=129eb2c8&lang=scss&scoped=true&"
import style1 from "./ExamQuestion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129eb2c8",
  null
  
)

export default component.exports